import { useState, useEffect } from 'react';

const useCountdown = (initialCount: number) => {
  const [countdown, setCountdown] = useState(initialCount);
  const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isCounting && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, countdown]);

  const startCountdown = () => {
    setCountdown(initialCount);
    setIsCounting(true);
  };

  return { countdown, isCounting, startCountdown };
};

export default useCountdown;
